<mat-form-field class="fill"  [ngClass]="classes">

  <mat-label *ngIf="label"> {{label}}</mat-label>
  <mat-select (openedChange)="openedChange($event)"
              (selectionChange)="emitSelect($event)"
              [formControl]="selectFormControl"
  >

    <div class="select-container">
      <mat-optgroup>
        <mat-form-field class="search">
          <!--          TODO ADD PLACEHOLDER FOR SEARCH-->
          <input #search autocomplete="off" placeholder="{{placeholder}}" (focus)="placeholder = ''"
                 (keydown.space)="$event.stopPropagation()"
                 matInput [formControl]="searchTextboxControl">
          <i class="fa fa-times fa-2x" matTooltip="Clear search" matSuffix mat-icon-button aria-label="Clear"
             (click)="clearSearch($event)">
          </i>
        </mat-form-field>
      </mat-optgroup>
      <mat-optgroup *ngIf="filteredOptions && filteredOptions.length == 0">
        <div>No results found!</div>
      </mat-optgroup>
      <mat-option *ngIf="selectFormControl.value && selectFormControl.value.attributes" [value]="selectFormControl.value"
                  style="display: block; width: 100%; height: 30px;overflow:hidden;">
        {{selectFormControl.value.attributes.name}}
        {{selectFormControl.value.attributes.description ? ' - ' + selectFormControl.value.attributes.description: ''}}
      </mat-option>

      <virtual-scroller #scroll
                        *ngIf="filteredOptions" [items]="filteredOptions" class="virtual-scroller"
                        style="width: 100%;  height: 200px;">
        <mat-option *ngFor="let option of scroll.viewPortItems" [value]="option" [title]="description_map[option.id]"
                    style="display: block; width: 100%; height: 30px;"
                    [style.font-weight]="selectFormControl.value && selectFormControl.value.id==option.id ? 'bold' : 'normal'">
          {{description_map[option.id]}}
        </mat-option>
      </virtual-scroller>
    </div>
  </mat-select>
</mat-form-field>
<!--<mat-select placeholder="Select correction method here" [(value)]="selected_correction_method"-->
<!--style="display: inline-block" (selectionChange)="clearVariables()">-->

<!--<div *ngIf="selectFormControl.value">{{ 'You have choosen ' + selectFormControl.value[] }}</div>-->

<!-- Copyright 2018 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->